import React from "react";
import { useLocation } from "react-router-dom";
import { readReviewEntry } from "../hooks/useHomeEnrichmentReviewEntry";
import HomeExecutionReview from "./HomeExecutionReview";

/** Keep the live route unmounted while restoring an original run. */
export default function withHomeExecutionReview(Content) {
  return function HomeReviewRoute(props) {
    const entry = readReviewEntry(useLocation().state);
    return entry ? <HomeExecutionReview key={entry.executionId} /> : <Content {...props} />;
  };
}
